import dynamic from 'next/dynamic';
import { useState, type FunctionComponent } from 'react';

import { SortIcon } from '@/domains/core/tamagoshiTailwind/icons/SortIcon';
import { getIndexes } from '@/domains/productDiscovery/algolia/settings/settings.common';
import { useCurrentIndex } from '@/domains/productDiscovery/Listings/hooks/useCurrentIndex';

import type { SortModalProps } from '../../../SortModal/SortModal';
import { QuickFilterButton } from '../QuickFilterButton/QuickFilterButton';
import { translations } from './translations';

const DynamicSortModal = dynamic<SortModalProps>(
  () => import('../../../SortModal/SortModal').then((mod) => mod.SortModal),
  { ssr: false },
);

export const QuickOpenSortModal: FunctionComponent = () => {
  const indexes = getIndexes();
  const currentIndex = useCurrentIndex();
  const urlKey =
    indexes.find((index) => index.value === currentIndex)?.urlKey ||
    'relevance';

  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <>
      <QuickFilterButton
        onClick={openModal}
        text={translations[urlKey]}
        icon={SortIcon}
      />
      {isOpen && <DynamicSortModal onClose={closeModal} />}
    </>
  );
};

QuickOpenSortModal.displayName = 'QuickOpenSortModal';
